export default "__VITE_ASSET__CMP1EQyP__"